import {components, pages} from "../config";

const contentModules: any = {
  [pages.aboutUs]: {
    en: () => import('./about-us-en')
  },
  [pages.contactUs]: {
    en: () => import('./contact-details-en')
  },
  [pages.services]: {
    en: () => import('./our-services-en')
  },
  [pages.leasingAndRental]: {
    en: () => import('./leasing-and-rental-en')
  },
  [pages.assetsAndPropertyManagement]: {
    en: () => import('./assets-and-property-management-en')
  },
  [pages.b2bPage]: {
    en: () => import('./b2b-page-en')
  },
  [pages.careers]: {
    en: () => import('./careers-en')
  },
  [pages.ourTeam]: {
    en: () => import('./our-team-en')
  },
  [components.navigation]: {
    en: () => import('./navigation-en')
  },
  [components.commonTexts]: {
    en: () => import('./common-text-en')
  },
  [components.forms]: {
    en: () => import('./form-en')
  },
  [components.filters]: {
    en: () => import('./filter-labels-en')
  }
};

export async function loadContent(page: string, language: string): Promise<any> {
  try {
    if (contentModules[page]) {
      return await contentModules[page].en();
    } else {
      console.log(`Content for page: ${page} and language: ${language} not found.`);
    }
  } catch (error) {
    throw error;
  }
}
